export const Model = Object.freeze({
	Absences: 'absences',
	CheckList: 'check-list',
	CrmItems: 'crm-items',
	Epics: 'epics',
	Flows: 'flows',
	GanttLinks: 'gantt-links',
	Groups: 'groups',
	Interface: 'interface',
	Placements: 'placements',
	Results: 'results',
	Stages: 'stages',
	Tasks: 'tasks',
	Users: 'users',
	Reminders: 'reminders',
	ElapsedTimes: 'elapsed-times',
});
